import { styled } from '../../Utilities';
import { getStyles } from './GroupHeader.styles';
import { GroupHeaderBase } from './GroupHeader.base';
export var GroupHeader = styled(GroupHeaderBase, getStyles, undefined, {
  scope: 'GroupHeader'
});